<template>

  <div class="advertiser-container">
    <div>邮件/微信记录</div>

    <el-row type="flex" justify="end">
				<el-button @click.native.prevent="onItemNewClick()"  icon="el-icon-plus" type="primary">创建邮件/微信
				</el-button>
        <el-button @click="ExportList()"  icon="el-icon-plus" type="primary">导出</el-button>
        <!-- <el-button @click="ExportList()"  icon="el-icon-plus" type="primary">导出
				</el-button> -->
	</el-row>
    <el-form inline :model="searchForm" label-width="180px" style="margin-top: 30px;">
      <el-row>
        <el-form-item label="填写日期">
          <el-date-picker
          v-model="searchForm.dateArray"
          type="daterange"
          range-separator="至"
          value-format="yyyy-M-d"
          start-placeholder="年/月/日"
          end-placeholder="年/月/日">
        </el-date-picker>
      
      </el-form-item>
    </el-row>
    <el-row>
        <el-form-item label="Email或微信主题/工单号/收(发)件人邮箱" label-width="300px">
            <el-input v-model="searchForm.searchkey" autocomplete="off"></el-input>
        </el-form-item>
        <el-button @click="onSearch" type="primary" icon="el-icon-search">查询</el-button>
      </el-row>
      
    </el-form>

    
    <el-table 
      :data="emailLogList.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
      border :header-cell-style="{background:'#eef1f6',color:'#606266'}"  height="750"
			style="width: 80%;margin-top: 10px;" ref="Table" >      
      <el-table-column prop="emailId" align="center" label="序号" ></el-table-column>
      <el-table-column prop="sheetCode" align="center" label="工单号" >
          <!-- <template slot-scope="scope">
            <el-button v-if="scope.row.sheetCode" type="text" @click="onItemEditClick(scope.row)">{{scope.row.sheetCode}}</el-button>   
            <el-button v-else type="text" @click="onItemEditClick(scope.row)">绑定</el-button>           
        </template> -->
      </el-table-column>
      <el-table-column prop="title" align="center" label="邮件/微信主题" ></el-table-column>
      <!-- <el-table-column prop="content" align="center" label="邮件内容" ></el-table-column> -->
      <el-table-column prop="fromEmail" align="center" label="发件人" ></el-table-column>
      <el-table-column prop="toEmail" align="center" label="收件人" ></el-table-column>
      <el-table-column prop="sendTime" align="center" label="发送时间"></el-table-column>
      <el-table-column prop="rowTime" align="center" label="创建时间" ></el-table-column>
      <el-table-column  align="center" label="操作" >
        <template slot-scope="scope">
          <el-button-group>
            <el-button type="primary" size="small"
            @click.native.prevent="onItemEditClick(scope.row)"
          >编辑</el-button>
          <el-button type="danger" size="small"
            @click.native.prevent="onItemDeleteClick(scope.row)"
          >删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <div class="tabListPage">
           <el-pagination @size-change="handleSizeChange" 
                          @current-change="handleCurrentChange" 
                          :current-page="currentPage" 
                          :page-sizes="pageSizes" 
                          :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                          :total="totalCount">
             </el-pagination>
       </div>
    <edit-dialog :visible.sync="setCodeVisible" :date-array="searchForm.dateArray"  :searchkey="searchForm.searchkey" :current-item="currentItem"/>
  </div>
</template>

<script>

import CommonTable from "@/components/CommonTable";
import {getLatestMonthDateArrayByDate} from "@/utils/time";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import {encrypt} from "@/utils/encrypt";
import {EmailDelete} from "@/api/bd";
import EditDialog from "@/views/EmailLog/editDialog";
import {dealDeleteOperation} from "@/utils/tools";

export default {
  name: "Advertiser",
  components: { CommonTable,EditDialog}, 
  computed: { ...mapGetters(["emailLogList"]) },
  data() {
    return {
      setCodeVisible: false,
      searchForm: {
        searchkey: "",
        dateArray: getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'}),
      },
      currentItem: {},
      
      // 默认显示第几页
           currentPage:1,
           // 总条数，根据接口获取数据长度(注意：这里不能为空)
           totalCount:0,
           // 个数选择器（可修改）
           pageSizes:[20,50,100],
           // 默认每页显示的条数（可修改）
           PageSize:50,

    };
  },
 

  async created() {
    this.onSearch();
  },

  methods: {    
    async onItemEditClick(item) {
			// var id =encrypt(item.emailId);
		  // this.$router.push({name: 'EditEmail', params: {Id: id}});
      this.currentItem = item;
			this.setCodeVisible = true;
		},

    async onItemNewClick(){
      this.currentItem = {};
			this.setCodeVisible = true;
    },

    async onItemDeleteClick(item) {
						console.log(item);
						await dealDeleteOperation({deletePromise: EmailDelete({userId:getToken(), emailId: item.emailId})})
						await this.onSearch();
		},

    
    
      // 分页
        // 每页显示的条数
       handleSizeChange(val) {
           // 改变每页显示的条数 
           this.PageSize=val
           // 注意：在改变每页显示的条数时，要将页码显示到第一页
           this.currentPage=1
       },
         // 显示第几页
       handleCurrentChange(val) {
           // 改变默认的页数
           this.currentPage=val
           this.stopAll();
       },

    async ExportList(){
      const [sDate, eDate] = this.searchForm.dateArray;
		  await this.$store.dispatch('bd/EmailLogListExport', {
							sDate:sDate,
							eDate:eDate,
              key:this.searchForm.searchkey
							});
    },

    async onSearch() {
        const [sDate, eDate] = this.searchForm.dateArray;

      await this.$store.dispatch("bd/emailLogList", {
        sDate,
        eDate,
        key:this.searchForm.searchkey
      }).then(res=>{
          this.$refs.Table.doLayout();
          this.totalCount=this.emailLogList.length
          console.log('this.emailLogList',this.emailLogList)
          this.currentPage=1
      });


    },


  },
};
</script>

<style scoped>

</style>